module.exports = __webpack_public_path__ + "static/img/nodata.b020ccf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spreader/nodata.png
// module id = t65b
// module chunks = 1